import { Component, ElementRef, Input, NgZone, Renderer2, ViewChild } from '@angular/core';
import { animate, AnimationOptions } from 'popmotion';

export interface ArtworkAnimation {
  el: ElementRef,
  props: Array<{ name: string, from: string, to: string }>,
}

@Component({
  selector: 'app-landing-artworks',
  templateUrl: './artworks.component.html',
  styleUrls: ['./artworks.component.scss']
})
export class LandingArtworksComponent {

  @Input() selectedArtwork: { id: number, name: string, img: string } | null = null;
  
  @ViewChild('pyArtwork') pyArtwork: ElementRef | undefined;
  @ViewChild('mod2') mod2: ElementRef | undefined;
  @ViewChild('mod3') mod3: ElementRef | undefined;
  @ViewChild('mod4') mod4: ElementRef | undefined;
  @ViewChild('mod5') mod5: ElementRef | undefined;
  @ViewChild('mod6') mod6: ElementRef | undefined;
  @ViewChild('mod7') mod7: ElementRef | undefined;
  @ViewChild('mod8') mod8: ElementRef | undefined;
  @ViewChild('mod9') mod9: ElementRef | undefined;
  @ViewChild('mod10') mod10: ElementRef | undefined;

  artworkSpringAnimationConfig: {type: 'spring', stiffness: number, damping: number, mass: number} = {
    type: 'spring',
    mass: 1,
    stiffness: 300,
    damping: 20,
  };

  constructor(private renderer: Renderer2, private zone: NgZone) {}
  
  animateArtworkForward(animations: Array<ArtworkAnimation>): void {
    animations.forEach(animation => {
      animation.props.forEach(prop => {
        animate(<AnimationOptions<string>>{
          from: prop.from,
          to: prop.to,
          type: this.artworkSpringAnimationConfig.type,
          stiffness: this.artworkSpringAnimationConfig.stiffness,
          damping: this.artworkSpringAnimationConfig.damping,
          mass: this.artworkSpringAnimationConfig.mass,
          onUpdate: (value) => {
            this.renderer.setStyle(animation.el, prop.name, value);
          }
        });
      });
    });
  }

  animateArtworkBackward(animations: Array<ArtworkAnimation>): void {
    animations.forEach(animation => {
      animation.props.forEach(prop => {
        animate(<AnimationOptions<string>>{
          from: prop.from,
          to: prop.to,
          type: this.artworkSpringAnimationConfig.type,
          stiffness: this.artworkSpringAnimationConfig.stiffness,
          damping: this.artworkSpringAnimationConfig.damping,
          mass: this.artworkSpringAnimationConfig.mass,
          onUpdate: (value) => {
            this.renderer.setStyle(animation.el, prop.name, value);
          }
        });
      });
    });
  }

  animatePyForward(): void {
    const py = this.pyArtwork?.nativeElement;
    const animations = [];
    const pyFront = py?.querySelector('.py-front');
    const pyLines = py?.querySelector('.py-lines');
    animations.push({
      el: pyFront,
      props: [
        { name: 'width', from: '135px', to: '206px' },
        { name: 'height', from: '135px', to: '206px' },
      ]
    });
    animations.push({
      el: pyLines,
      props: [
        { name: 'width', from: '216px', to: '100%' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animatePyBackward(): void {
    const py = this.pyArtwork?.nativeElement;
    const animations = [];
    const pyFront = py?.querySelector('.py-front');
    const pyLines = py?.querySelector('.py-lines');
    animations.push({
      el: pyFront,
      props: [
        { name: 'width', from: '206px', to: '135px' },
        { name: 'height', from: '206px', to: '135px' },
      ]
    });
    animations.push({
      el: pyLines,
      props: [
        { name: 'width', from: '100%', to: '216px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod2Forward(): void {
    const mod = this.mod2?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'height', from: '180px', to: '270px' },
        { name: 'right', from: '-75px', to: '-65px' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod2Backward(): void {
    const mod = this.mod2?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'height', from: '270px', to: '180px' },
        { name: 'right', from: '-65px', to: '-75px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod3Forward(): void {
    const mod = this.mod3?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'top', from: '-40px', to: '-160px' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod3Backward(): void {
    const mod = this.mod3?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'top', from: '-160px', to: '-40px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod4Forward(): void {
    const mod = this.mod4?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'left', from: '40px', to: '-100px' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod4Backward(): void {
    const mod = this.mod4?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'left', from: '-100px', to: '40px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod5Forward(): void {
    const mod = this.mod5?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'right', from: '25px', to: '-140px' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod5Backward(): void {
    const mod = this.mod5?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'right', from: '-140px', to: '25px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod6Forward(): void {
    const mod = this.mod6?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    // const light = mod?.querySelector('.light');
    animations.push({
      el: modImg,
      props: [
        { name: 'width', from: '460px', to: '760px' },
        { name: 'top', from: '50%', to: '20%' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod6Backward(): void {
    const mod = this.mod6?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'width', from: '760px', to: '460px' },
        { name: 'top', from: '20%', to: '50%' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod7Forward(): void {
    const mod = this.mod7?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'height', from: '240px', to: '325px' },
        { name: 'top', from: '50%', to: '10%' },
        { name: 'right', from: '-70px', to: '-140px' },
        { name: 'transform', from: 'rotate(-45deg)', to: 'rotate(-15deg)' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod7Backward(): void {
    const mod = this.mod7?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img');
    animations.push({
      el: modImg,
      props: [
        { name: 'height', from: '325px', to: '240px' },
        { name: 'top', from: '10%', to: '50%' },
        { name: 'right', from: '-140px', to: '-70px' },
        { name: 'transform', from: 'rotate(-15deg)', to: 'rotate(-45deg)' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod8Forward(): void {
    const mod = this.mod8?.nativeElement;
    const animations = [];
    const modImgR = mod?.querySelector('.mod-img-r');
    const modImgL = mod?.querySelector('.mod-img-l');
    animations.push({
      el: modImgR,
      props: [
        { name: 'top', from: '20px', to: '100px' },
      ]
    });
    animations.push({
      el: modImgL,
      props: [
        { name: 'top', from: '20px', to: '-135px' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod8Backward(): void {
    const mod = this.mod8?.nativeElement;
    const animations = [];
    const modImgR = mod?.querySelector('.mod-img-r');
    const modImgL = mod?.querySelector('.mod-img-l');
    animations.push({
      el: modImgR,
      props: [
        { name: 'top', from: '100px', to: '20px' },
      ]
    });
    animations.push({
      el: modImgL,
      props: [
        { name: 'top', from: '-135px', to: '20px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod9Forward(): void {
    const mod = this.mod9?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img-arc');
    animations.push({
      el: modImg,
      props: [
        { name: 'transform', from: 'translate(-50%, -50%) rotate(29.17deg)', to: 'translate(-50%, -50%) rotate(-143.97deg)' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod9Backward(): void {
    const mod = this.mod9?.nativeElement;
    const animations = [];
    const modImg = mod?.querySelector('.mod-img-arc');
    animations.push({
      el: modImg,
      props: [
        { name: 'transform', from: 'translate(-50%, -50%) rotate(-143.97deg)', to: 'translate(-50%, -50%) rotate(29.17deg)' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

  animateMod10Forward(): void {
    const mod = this.mod10?.nativeElement;
    const animations = [];
    const modImgGlobe = mod?.querySelector('.mod-img-globe');
    const modImgUpwork = mod?.querySelector('.mod-img-upwork');
    const modImgLinkedin = mod?.querySelector('.mod-img-linkedin');
    animations.push({
      el: modImgGlobe,
      props: [
        { name: 'width', from: '209px', to: '270px' },
        { name: 'transform', from: 'translate(-50%, -50%) rotate(0deg)', to: 'translate(-50%, -50%) rotate(-14.5deg)' },
      ]
    });
    animations.push({
      el: modImgUpwork,
      props: [
        { name: 'left', from: '40px', to: '-18px' },
      ]
    });
    animations.push({
      el: modImgLinkedin,
      props: [
        { name: 'right', from: '40px', to: '28px' },
      ]
    });
    this.animateArtworkForward(animations);
  }

  animateMod10Backward(): void {
    const mod = this.mod10?.nativeElement;
    const animations = [];
    const modImgGlobe = mod?.querySelector('.mod-img-globe');
    const modImgUpwork = mod?.querySelector('.mod-img-upwork');
    const modImgLinkedin = mod?.querySelector('.mod-img-linkedin');
    animations.push({
      el: modImgGlobe,
      props: [
        { name: 'width', from: '270px', to: '209px' },
        { name: 'transform', from: 'translate(-50%, -50%) rotate(-14.5deg)', to: 'translate(-50%, -50%) rotate(0deg)' },
      ]
    });
    animations.push({
      el: modImgUpwork,
      props: [
        { name: 'left', from: '-18px', to: '40px' },
      ]
    });
    animations.push({
      el: modImgLinkedin,
      props: [
        { name: 'right', from: '28px', to: '40px' },
      ]
    });
    this.animateArtworkBackward(animations);
  }

}
